import { ButtonBase, Typography, styled } from '@mui/material';
import { IconButton } from 'components/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { monthToString } from 'utils/utils';
import { calendarLayout } from './constants';
import { Month } from './utils';

const Header = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(calendarLayout.sectionGap),
}));

const MonthButton = styled(ButtonBase)(({ theme }) => ({
    'display': 'inline-flex',
    'alignItems': 'center',
    'gap': theme.spacing(calendarLayout.compactGap),
    'padding': theme.spacing(
        calendarLayout.compactGap,
        calendarLayout.sectionGap
    ),
    'borderRadius': theme.shape.borderRadius,
    'color': theme.palette.text.primary,
    'userSelect': 'none',
    '&:hover': {
        backgroundColor: theme.palette.grey[100],
    },
}));

const Navigation = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(calendarLayout.compactGap),
}));

interface CalendarHeaderProps {
    month: Month;
    isSelectorOpen: boolean;
    canGoPrevious: boolean;
    canGoNext: boolean;
    onToggleSelector: () => void;
    onPrevious: () => void;
    onNext: () => void;
}

export const CalendarHeader = ({
    month,
    isSelectorOpen,
    canGoPrevious,
    canGoNext,
    onToggleSelector,
    onPrevious,
    onNext,
}: CalendarHeaderProps) => {
    return (
        <Header>
            <MonthButton onClick={onToggleSelector}>
                <Typography variant='body2' fontWeight={600}>
                    {monthToString(month.month + 1)} {month.year}
                </Typography>
                {isSelectorOpen ? (
                    <KeyboardArrowUpIcon
                        sx={{ fontSize: 18, color: 'text.secondary' }}
                    />
                ) : (
                    <KeyboardArrowDownIcon
                        sx={{ fontSize: 18, color: 'text.secondary' }}
                    />
                )}
            </MonthButton>
            <Navigation>
                <IconButton
                    icon='arrow_back'
                    variant='text'
                    size='xs'
                    onClick={onPrevious}
                    disabled={!canGoPrevious}
                />
                <IconButton
                    icon='arrow_forward'
                    variant='text'
                    size='xs'
                    onClick={onNext}
                    disabled={!canGoNext}
                />
            </Navigation>
        </Header>
    );
};

export default CalendarHeader;
